<template>
    <div class="cookie-banner" :class="{ 'cookie-banner--visible': visible }">
        <button
            class="cookie-banner__close"
            @click="acceptCookiesUsage"
            aria-label="Принять и закрыть"
            title="Принять и закрыть"
        >
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5004 14.4003L22.2991 24.2016L24.2018 22.3015L14.4005 12.5002L24.2018 2.70158L22.3018 0.798828L12.5004 10.6001L2.70182 0.798828L0.801758 2.70158L10.6004 12.5002L0.801758 22.2988L2.70182 24.2016L12.5004 14.4003Z" fill="#000"/>
            </svg>


        </button>
        <div class="cookie-banner__text">
            Продолжая пользоваться сайтом, вы даёте
            <a
                href="#"
                class="link-underline"
                target="_blank"
                rel="noopener"
                aria-label="Согласие на автоматический сбор и анализ ваших данных"
                >Согласие</a
            >
            на автоматический сбор и анализ ваших данных, необходимых для работы сайта и его улучшения,
            использование файлов cookie.
        </div>
    </div>
</template>

<script lang="ts">
import * as Cookies from 'js-cookie';

type Data = {
    visible: boolean;
    timer: NodeJS.Timeout | null;
};

export default {
    props: {
        revealTimeout: {
            type: Number,
            default: 5000,
        },
    },

    data(): Data {
        return {
            visible: false,
            timer: null,
        };
    },

    mounted() {
        this.timer = setTimeout(() => {
            this.visible = true;
        }, this.revealTimeout);
    },

    beforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    },

    methods: {
        close() {
            this.visible = false;
        },

        acceptCookiesUsage() {
            Cookies.set('COOKIES_USAGE_ACCEPTED', 'true', {
                expires: Infinity,
            });
            this.close();
        },
    },
};
</script>

<style lang="scss">
@import '../../../../css/base/variables';

.cookie-banner {
    position: fixed;
    z-index: 28;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 570px;
    background-color: #fff;
    padding: 44px 56px 32px 56px;
    text-align: left;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    transition: opacity 0.5s ease, visibility 0.5s ease;
    /* contain: content; */

    &:not(.cookie-banner--visible) {
        opacity: 0;
        visibility: hidden;
    }

    @media (min-width: 1921px) {
        font-size: 16px;
    }

    @media screen and (max-width: 767px) {
        bottom: auto;
        left: 0;
        transform: none;
        max-width: 100%;
        padding: 20px;
        padding-top: 15px;
        border-radius: 0;
    }
}

.cookie-banner__text {
    font-weight: bold;
}

.cookie-banner__close {
    background-color: transparent;
    border: 0;
    padding: 0;
    position: absolute;
    top: 16px;
    right: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.cookie-banner__close svg {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
}

</style>
